import { isCDNEnabled } from '../utils/mediaCdn';
export var getArtifactUrl = function getArtifactUrl(artifacts, prop) {
  var _artifacts$prop, _artifacts$prop3;
  // eslint-disable-next-line @atlaskit/platform/no-preconditioning
  if (isCDNEnabled() && (_artifacts$prop = artifacts[prop]) !== null && _artifacts$prop !== void 0 && _artifacts$prop.url) {
    var _artifacts$prop2;
    return "".concat((_artifacts$prop2 = artifacts[prop]) === null || _artifacts$prop2 === void 0 ? void 0 : _artifacts$prop2.url, "/cdn");
  }
  return (_artifacts$prop3 = artifacts[prop]) === null || _artifacts$prop3 === void 0 ? void 0 : _artifacts$prop3.url;
};